import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Ukrainian Tax Number validator following Single Responsibility Principle
 */
export class UaValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Ukrainian Tax Number',
      pattern: /^\d{10}$/,
      length: 10
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Ukrainian Tax Number must be exactly 10 digits'
    );
  }

  validateChecksum(id) {
    const weights = [-1, 5, 7, 9, 4, 6, 10, 5, 7];
    let sum = 0;

    for (let i = 0; i < 9; i++) {
      sum += parseInt(id[i]) * weights[i];
    }

    let expectedChecksum = sum % 11;
    if (expectedChecksum >= 10) {
      // Recalculate with different weights
      const weights2 = [7, 1, 3, 5, 8, 2, 4, 6, 9];
      sum = 0;
      for (let i = 0; i < 9; i++) {
        sum += parseInt(id[i]) * weights2[i];
      }
      expectedChecksum = sum % 11;
      if (expectedChecksum >= 10) {
        expectedChecksum = 0;
      }
    }

    const actualChecksum = parseInt(id[9]);
    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid Ukrainian Tax Number checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid Ukrainian Tax Number');
  }
}